<template>
    <div class="search-box">
        <el-input

                v-model="keyword"
                size="large"
                :name="inputName"
                :placeholder="`${i18n.tkey('lang_search_text')}...`"
                :prefix-icon="Search"
                autocomplete ="off"
                :readonly ="isreadonly"
                :class="'no-autofill-pwd'"
                auto-complete="new-password"
                :type="inputType"
                clearable
                style="width: calc(100% - 80px);"
        />
      <el-button style="margin-left: 5px;"  type="primary" tkey="搜索" @click="changeKeyword">{{i18n.tkey("lang_search_text")}}</el-button>

    </div>
</template>

<script setup>
    import {inject, onMounted, ref, watch} from "vue";
    import {Search} from '@element-plus/icons-vue';
    import myUtil from "@/util/util";

    const i18n = inject("i18n")

    const props = defineProps(['modelValue'])
    const emits = defineEmits(['update:modelValue', 'change'])

    const keyword = ref("")
    const inputName = ref("")
    const isreadonly = ref(true)
    const inputType = ref("password")


    function changeKeyword(){
      setTimeout(function (){
        emits('update:modelValue', keyword.value)
        emits("change", keyword.value)
      },500)
    }

    watch(() => props.modelValue, (newValue, oldValue) => {
      isreadonly.value=true;
      setTimeout(function (){
        keyword.value = newValue
        isreadonly.value=false;
        if(myUtil.isEmpty(newValue)){
          keyword.value = ""
        }
      },1000)
    })

    onMounted(() => {
        keyword.value = props.modelValue
        inputName.value= Math.random();
        setTimeout(function (){
          isreadonly.value=false;

        },1000)
      setTimeout(function (){
        keyword.value=""
        inputType.value="text"
        console.log("清除")
      },2000)
    })

</script>

<style scoped>
    .search-box {
        text-align: center;
        margin-bottom: 20px;
    }

    .no-autofill-pwd {
      /deep/ .el-input__inner {
        -webkit-text-security: disc !important;
      }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active  {
      transition: background-color 5000s ease-in-out 0s;
    }
</style>